import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GaTrackingShowTooltipValueAddedServiceEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ShowTooltipValueAddedService;
  }

  getPayload(): GATrackingEventPayload {
    return {
      category: this.payload.category,
      event: GaTrackingEventName.ShowTooltipValueAddedService,
      label: this.payload.label,
      gtmCustom: {
        action: this.payload.action,
        category: this.payload.category,
      },
    };
  }
}
